import type { Resource } from "../../types/Resource";
import { getResourceRowHeight } from "./getResourceRowHeight";

export const getResourceIndexFromY = (y: number, resources: Resource[], resourceLayouts: any): number => {
    let cumulativeHeight = 0;
    for (let i = 0; i < resources.length; i++) {
        cumulativeHeight += getResourceRowHeight(resources[i].id, resourceLayouts);
        if (y < cumulativeHeight) return i;
    }
    return -1;
};
